/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagsSearchResultDTO
 */
export interface TagsSearchResultDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof TagsSearchResultDTO
     */
    tags: Array<string>;
}

/**
 * Check if a given object implements the TagsSearchResultDTO interface.
 */
export function instanceOfTagsSearchResultDTO(value: object): value is TagsSearchResultDTO {
    if (!('tags' in value) || value['tags'] === undefined) return false;
    return true;
}

export function TagsSearchResultDTOFromJSON(json: any): TagsSearchResultDTO {
    return TagsSearchResultDTOFromJSONTyped(json, false);
}

export function TagsSearchResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagsSearchResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'tags': json['tags'],
    };
}

export function TagsSearchResultDTOToJSON(value?: TagsSearchResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tags': value['tags'],
    };
}

